

































































































import { Component, Emit, Model, Prop, Ref, Vue, Watch, PropSync } from 'vue-property-decorator';
import CardTitle from '@/components/common/CardTitle.vue';
import Decisions from '@/store/modules/Decisions';
import { getModule } from 'vuex-module-decorators';
import Viewpoints from '@/store/modules/Viewpoints';
import { Viewpoint } from '@/api/model/Viewpoint';
import Users from '@/store/modules/Users';
import moment from 'moment';
import Choices, { Choice } from '@/store/modules/Choices';

const decisionsModule = getModule(Decisions);
const viewpointModule = getModule(Viewpoints);
const userModule = getModule(Users);
const choicesModule = getModule(Choices);
@Component({
    components: {
        CardTitle
    }
})
export default class CreateChoiceDialog extends Vue {

    @Prop({
        type: Boolean,
        default: false,
    }) 
    showDialogProp!: boolean;

    @Prop({ default:false, type: Boolean })
    isEdit!: boolean

    @Prop({ default: ()=>({}), type: Object })
    choice!: any | null;

    @Prop({ default: false, type:Boolean })
    showTable!: boolean;

    private showDialog = false;
    private loading = false;
    private choiceName = "";

    get singularChoiceLabel() {
        return decisionsModule.singularChoiceLabel;
    }

    get pluralChoiceLabel() {
        return decisionsModule.pluralChoiceLabel;
    }

    get choicesList() {
        return choicesModule.choicesList;
    }

    get currentUser() {
        return userModule.currentUserProfile;
    }

     get headers() {
        return [
            {
                text: '',
                value: 'actions',
                sortable: false,
                width: 24,
            },
            {
                text: this.singularChoiceLabel,
                value: 'name',
                width: '25%',
            },
            {
                text: 'Updated',
                value: 'lastUpdatedTimestamp',
                width: 120,
            },
            {
                text: 'Create',
                value: 'creationTimestamp',
                width: 120,
            },
            {
                text: 'Owner',
                value: 'ownerUserId',
                width: 150,
            },
        ];
    }

    mounted() {
        this.showDialog = this.showDialogProp;
        
    }

    get choicesOwnedByUser(): Choice[] {
        if(this.choicesList == null) {
            return [];
        }

        return this.choicesList.filter((choice: Choice) => choice.ownerUserId === this.currentUser.userId);
    }

    get username(): string {
        if(this.currentUser.first && this.currentUser.last) {
            return `${this.currentUser.first} ${this.currentUser.last}`
        } else {
            return this.currentUser.email
        }
    }

    @Watch('showDialogProp')
    onChangeShowDialogProp() {
        this.showDialog = this.showDialogProp;
        if (this.isEdit) {
            this.choiceName = this.choice.name;
        } else {
            this.choiceName = '';
        }
    }

    private formatDate(dateString: string) {
        return moment(dateString).format('YYYY-MM-DD');
    }

    private getUserNameFromId(userId: string) {
        let user = decisionsModule.selectedDecisionUsers[userId];
        if(user){
            return user.first || user.last ? user.first + ' ' + user.last : user.email;
        } else{
            return 'Guest';
        }
    }
    

    @Emit('cancel')
    private cancel() {}

    @Emit('save')
    private save() {}

    @Emit('clear')
    private clear() {}

    @Emit('update')
    private update() {}

    @Emit('close')
    private close() {}

    private editChoice(choice: Choice) {
        this.$emit('continue', choice);
        this.showDialog = false;
    }

    private submit() {
        if(this.choiceName === '') {
            return;
        }
        this.$emit("save", this.choiceName);
        this.showDialog = false;
    }
}
